var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "display-block" },
    [
      _c("data-table", {
        attrs: {
          rows: _vm.rows,
          columns: _vm.columns,
          "page-size": _vm.pageSize,
          "page-size-options": _vm.pageSizeOptions,
          classes: _vm.classes,
          labels: _vm.labels,
          "sort-prop": "sort",
          "show-pager": !_vm.IS_MOBILE,
          "show-toolbar": !_vm.IS_MOBILE,
          "filter-prop": "value",
          "sort-functions": _vm.sortFunctions,
        },
      }),
      _vm._v(" "),
      _vm.showMoreButton
        ? _c("div", { staticClass: "statTable__expand padding-bottom-5" }, [
            _c(
              "button",
              {
                staticClass: "statTable__expandButton",
                attrs: {
                  type: "button",
                  "data-gtm": "statistic__showMoreData",
                },
                on: { click: _vm.expandRows },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.trans("STATISTIC_SHOW_MORE_DATA")) +
                    "\n        "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }